import { render, staticRenderFns } from "./FormCreateCategory.vue?vue&type=template&id=4574f7de&"
import script from "./FormCreateCategory.vue?vue&type=script&lang=js&"
export * from "./FormCreateCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports